import { Marker as MapboxMarker } from 'mapbox-gl'
import { Marker as LeafletMarker } from 'leaflet'
import { GetCollectionsShowResponseMapLayers } from 'mytours-read-api-typescript'

export interface MapControls {
	showAllBounds?: () => void
	getMyPosition?: () => void
	showInAppDirections: (showInAppDirections: boolean) => void
}

export interface Marker {
	marker: MapboxMarker | LeafletMarker
	lat: number | string | null
	lng: number | string | null
	collectionItemId: number
	pinColor: string
	pinIcon: string
	pinStyle: string
	mapLayerId?: number
}

export interface SimpleCoordinates {
	lat: number | string | null
	lng: number | string | null
}

export type RouteProfile = 'cycling' | 'traffic' | 'driving' | 'walking'

export interface MapContainer {
	containerType: 'list' | 'tour' | 'section' | 'modal'
	containerId: number
}
export type StaticMapLayerType = GetCollectionsShowResponseMapLayers.LayerTypeEnum.Static
export type MapboxLayerType = GetCollectionsShowResponseMapLayers.LayerTypeEnum.Mapbox
export type GeoreferencedLayerType = GetCollectionsShowResponseMapLayers.LayerTypeEnum.Georeferenced

export const LayerTypeEnum = GetCollectionsShowResponseMapLayers.LayerTypeEnum
